module.exports = __webpack_public_path__ + "static/media/Quy-hoach-20.4162c9e5.svg";